import axiosIns from '@/plugins/axios'

export default {
  getIndividuallyConfirmableBusinessRuleAssignments() {
    return axiosIns.get('/v2/eod_closing/business_rule_assignments')
  },
}
